export enum ApiConnectionEndpoint {
  Base = '/connections',
  Search = '/search',
}
